import { useEffect } from 'react'
import * as S from './EmbeddedLogin.styles'
import MixtilesDialog from '../MixtilesDialog/MixtilesDialog'
import EmbeddedLoginContent from './EmbeddedLoginContent'
import { useAuth } from '../../services/AuthProvider/AuthProvider'
import { saveStateBeforeLogin } from '../../services/LoginUtills'
import { analytics, EVENT_NAMES } from '../../services/Analytics/Analytics'
import useScreenSize from '../../hooks/useScreenSize'
import BrowserThemeColor from '../ThemeColor/BrowserThemeColor'
import { photosTheme as theme } from 'mixtiles-web-common'

interface EmbeddedLoginProps {
  onDismiss: () => void
  open?: boolean
  onLoginProcessStart?: () => void
  source?: string
  skipRefresh?: boolean
}

function EmbeddedLogin({
  onDismiss,
  open = false,
  onLoginProcessStart,
  source,
  skipRefresh = false,
}: EmbeddedLoginProps) {
  const isMediumScreen = useScreenSize('md')
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (open) {
      saveStateBeforeLogin({ source })
      analytics.track(EVENT_NAMES.LOGIN_OR_SIGN_UP_DIALOG_OPENED, { source })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  useEffect(() => {
    if (isAuthenticated) {
      onDismiss()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  const embeddedLoginContent = (
    <EmbeddedLoginContent
      onLoginProcessStart={onLoginProcessStart}
      source={source}
      onDismiss={onDismiss}
      skipRefresh={skipRefresh}
    />
  )

  return (
    <>
      {isMediumScreen ? (
        <MixtilesDialog open={open} onDismiss={onDismiss} maxWidth={false}>
          {embeddedLoginContent}
        </MixtilesDialog>
      ) : (
        <S.BottomDrawer anchor="bottom" open={open} onClose={onDismiss}>
          <BrowserThemeColor color={theme.colors.dialogGray} enabled={open} />
          {embeddedLoginContent}
        </S.BottomDrawer>
      )}
    </>
  )
}

export default EmbeddedLogin
